import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputText from "../../helpers/InputText";


function CardNew(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


       const [errTab, setErrTab] = useState([]);  //z info od serwera..
 
       const [row, setRowX] = useState({
                card_id: "",
                opis: "",
                termin_waznosci_od: "2000-01-01",
                termin_waznosci_do: "2030-01-01",
        });
        var tmpRow = row;



        const [checked, setChecked] = useState(false);
        const handleChange = () => {
            setChecked(!checked);
          };


        const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    

        const valChangeListener = (filedName, val, correct, msg) => {         
            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
         
          
            tmpRow[filedName] = val;
            tmpRow[filedName+"_valid"] = correct;         
            setRowX(  JSON.parse(JSON.stringify(tmpRow)) );            
            //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
        } 

        

         
        const goNextNew = () => {
            console.log("goNext");
            saveData();
        }
    
        const saveData = () => {


 


            if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
        
    
            props.mainView.setProgress(-2);
    
            var req = row;
    
            fetch( Config.url + '/rest_v1_access,card_add', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            props.searchId(row.card_id);

                            props.mainView.showDialog( "Sukces",  "Karta została dodana", "ok" ,  (resp)=>{
                                props.onAdded(res.result);
                            } );                                                    

                        }else                       
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }







      return (
                 <div className="view_content">

                        <h1><PlTitle userData={props.userData} /> / Nowa karta</h1>
                    
                        
                        <form className="eForm bg_center">

                                     


                                    <div className="form_tab">

                                     

                                     

                                            <div className="form_control">
                                                <div className="fieldName">Numer karty (kliknij w pole i odczytaj czytnikiem)*</div>
                                                <InputText   userData={props.userData} value={row.card_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="card_id" placeholder={"CardID: "} className=' w200 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_split"></div>
                                       
                                            <div className="form_control">
                                                <div className="fieldName">Opis własny (np. Karta biała, Karta Tomka)</div>
                                                <InputText   userData={props.userData} value={row.opis} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opis" placeholder={"Nazwa: np. Smerfiki"} className=' w200 ' req='0' firstUp="1" />
                                            </div>


                                    </div>

   

                                    <div className="form_split"></div>

                                    <div className="form_btn">
                                            <div className="btn" onClick={saveData}>dodaj</div>
                                            &nbsp;&nbsp;
                                            <div className="btn" onClick={props.onBack}   > anuluj</div>
                                    </div>

                        </form>

                </div>
        )

}

export default CardNew;